import React from 'react';
import PropTypes from 'prop-types';
import Select from './Select';
import flags from '../../static-data/flags';
import config from './../../config';
import Preloader from '../Preloader';


const MedalTable = props => (
    <div className="medal__table">
        <div className="table__row table__row_filter">
            <div className="table__column table__column__title">Место</div>
            <div className="table__column table__column__select">
                <Select
                    updateFilter={props.updateFilter}
                    data={props.counties}
                    selected={props.selected}
                />
            </div>
            <div className="table__column table__column__sort">
                <span className="medal__icon medal__icon__gold">1</span>
                <span className="sort">
                    <button 
                        className={props.sortField === 'gold' && props.sortType === 'up' ? 'active' : ''}
                        onClick={() => { props.updateSort('gold', 'up'); }}
                    >
                        <svg className="icon icon-arrow-up" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-up" ></use>' }} />
                    </button>
                    <button 
                        className={props.sortField === 'gold' && props.sortType === 'down' ? 'active' : ''}
                        onClick={() => { props.updateSort('gold', 'down'); }}
                    >
                        <svg className="icon icon-arrow-down" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-down" ></use>' }} />
                    </button>
                </span>
            </div>
            <div className="table__column table__column__sort">
                <span className="medal__icon medal__icon__silver">2</span>
                <span className="sort">
                    <button
                        className={props.sortField === 'silver' && props.sortType === 'up' ? 'active' : ''}
                        onClick={() => { props.updateSort('silver', 'up'); }}
                    >
                        <svg className="icon icon-arrow-up" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-up" ></use>' }} /></button>
                    <button
                        className={props.sortField === 'silver' && props.sortType === 'down' ? 'active' : ''}
                        onClick={() => { props.updateSort('silver', 'down'); }}
                    >
                        <svg className="icon icon-arrow-down" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-down" ></use>' }} />
                    </button>
                </span>
            </div>
            <div className="table__column table__column__sort">
                <span className="medal__icon medal__icon__bronze">3</span>
                <span className="sort">
                    <button 
                        className={props.sortField === 'bronze' && props.sortType === 'up' ? 'active' : ''} 
                        onClick={() => { props.updateSort('bronze', 'up'); }}
                    >
                        <svg className="icon icon-arrow-up" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-up" ></use>' }} />
                    </button>
                    <button 
                        className={props.sortField === 'bronze' && props.sortType === 'down' ? 'active' : ''} 
                        onClick={() => { props.updateSort('bronze', 'down'); }}
                    >
                        <svg className="icon icon-arrow-down" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-down" ></use>' }} />
                    </button>
                </span>
            </div>
            <div className="table__column table__column__sort table__column__sort__group">
                <span className="medal__icon medal__icon__gold">1</span>
                <span className="medal__icon medal__icon__silver">2</span>
                <span className="medal__icon medal__icon__bronze">3</span>
                <span className="sort">
                    <button 
                        className={props.sortField === 'all' && props.sortType === 'up' ? 'active' : ''} 
                        onClick={() => { props.updateSort('all', 'up'); }}
                    >
                        <svg className="icon icon-arrow-up" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-up" ></use>' }} />
                    </button>
                    <button 
                        className={props.sortField === 'all' && props.sortType === 'down' ? 'active' : ''} 
                        onClick={() => { props.updateSort('all', 'down'); }}
                    >
                        <svg className="icon icon-arrow-down" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-down" ></use>' }} />
                    </button>
                </span>
            </div>
        </div>
        {props.data.length === 0 ? <Preloader /> : props.data.map((item, index) => (
            <div className={`table__row table__row__item ${item.checked ? 'checked_row' : ''}`} key={`medal_table_item_${item.code}`}>
                <div className="table__column table__column__position">{props.sortField === '' ? item.position : index + 1}</div>
                <div className="table__column table__column__flag" style={{ backgroundImage: `url(${config.imagesUrl}/images/flags/${flags[item.name]})` }} />
                <div className="table__column table__column__country">{item.name}</div>
                <div className="table__column table__column__medals">{item.first}</div>
                <div className="table__column table__column__medals">{item.second}</div>
                <div className="table__column table__column__medals">{item.third}</div>
                <div className="table__column table__column__medals">{item.total}</div>
            </div>
        ))}
    </div>
);

MedalTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    selected: PropTypes.string,
    counties: PropTypes.arrayOf(PropTypes.object),
    updateFilter: PropTypes.func.isRequired,
    updateSort: PropTypes.func.isRequired,
    sortField: PropTypes.string.isRequired,
    sortType: PropTypes.string.isRequired
};

MedalTable.defaultProps = {
    data: [],
    selected: '',
    counties: []
};

export default MedalTable;



// WEBPACK FOOTER //
// ./src/components/Medals/MedalTable.jsx